import FacebookIcon from '../../Components/Icons/Facebook/FacebookIcn';
import TwitterIcon from '../../Components/Icons/Twitter/TwitterIcn';
import SignInForm from '../../Components/Inputs/SignInForm/SignInForm';
import './SignIn.css';
import BlackLogo from '../../assets/img/Newsily logo-black.png';
import { Link } from 'react-router-dom';
import GoogleIcon from '../../Components/Icons/Google/GoogleIcn';




const SignIn = () => {
    return ( 
        <div className="signin">
            <div className="blacklogo">
            <img src={ BlackLogo } alt="black logo" />
            </div>
            <h2>Sign in to Newsily</h2>
            <SignInForm />
                <p>or</p>
            <div className="signin-icons">
            <FacebookIcon /> <TwitterIcon /><GoogleIcon />
            </div>
            <h4>Don’t have an account? <Link to ="/signup">Sign Up</Link></h4>
        </div>
     );
}
 
export default SignIn;